export function fmtEur(value: number): string {
    return value.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
}

export function fmtEur2(value: number): string {
    return value.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 });
}

export function fmtNum(value: number): string {
    return value.toLocaleString('fr-FR');
}

export function fmtPct(value: number): string {
    return `${value.toLocaleString('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} %`;
}

export function fmtJours(value: number): string {
    return `${Math.round(value)} j`;
}
